import { createCRUDHooks } from "@/lib/hooks-factory";
import { productBrandsApi } from "@/api/products/product-brands-api";
import type {
  ProductBrand,
  ProductBrandCreate,
  ProductBrandUpdate,
} from "@/types/products/api-types/product-brand-types";
import type { CRUDApiParams } from "@/lib/api-factory";

interface ProductBrandSearchParams extends CRUDApiParams {
  page?: number;
  size?: number;
  name?: string;
  active_only?: boolean;
}

const hooks = createCRUDHooks<ProductBrand, ProductBrandCreate, ProductBrandUpdate, ProductBrandSearchParams>({
  queryKey: "product-brands",
  api: productBrandsApi,
  invalidateKeys: ["products"],
  mapToOption: (brand: ProductBrand) => ({
    value: brand.id,
    label: brand.name,
  }),
  getLoadParams: (search: string, page: number, size: number): ProductBrandSearchParams => ({
    page,
    size,
    name: search || undefined,
    active_only: true,
  }),
});

export const useGetProductBrandsPaginated = hooks.useGetPaginated;
export const useCreateProductBrand = hooks.useCreate;
export const useUpdateProductBrand = hooks.useUpdate;
export const useDeleteProductBrand = hooks.useDelete;
export const useProductBrandLoadOptions = hooks.useLoadOptions!;
